import { useState } from 'react';
import { Link } from 'react-scroll';
import { links } from '../utils/links';
import styled from 'styled-components';
import { Icon } from '@iconify/react';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  return (
    <>
      <NavBarContainer name='nav'>
        <ToolbarContainer>
          <BrandContainer>
            {' '}
            <LeafIcon src='/leafIcon.png' />
            <BrandTitle>Speak Easy with Brandy</BrandTitle>
          </BrandContainer>

          <StyledBox>
            <Hamburger
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
              alt='menu-icon-nav'
            >
              <MenuIcon className='menu-icon' />
            </Hamburger>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              disableScrollLock={false}
            >
              {links.map(
                (link, idx) =>
                  idx > 0 && (
                    <MenuItem
                      key={idx}
                      onClick={handleCloseNavMenu}
                      onBlur={handleCloseNavMenu}
                    >
                      <Typography>
                        <Link
                          spy={true}
                          smooth={true}
                          duration={500}
                          to={link.to}
                        >
                          {link.name}
                        </Link>
                      </Typography>
                    </MenuItem>
                  )
              )}
            </Menu>
          </StyledBox>

          <NavMenu>
            {links.map((link, idx) => (
              <Link
                key={idx}
                to={link.to}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                <NavLink>{link.name}</NavLink>
              </Link>
            ))}

          </NavMenu>
        </ToolbarContainer>
      </NavBarContainer>
    </>
  );
};
export default Navbar;

const NavBarContainer = styled.div`
  background: linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (min-width: 375px) and (max-width: 768px) {
    padding: 0.8rem 1rem;
  }
`;

const BrandTitle = styled.h1`
  color: white;
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  font-family: 'Georgia', serif;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const BrandContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const LeafIcon = styled.img`
  height: 30px;
  width: 30px;
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.div`
  color: black;
  text-decoration: none !important;
  font-weight: 500;
  font-size: 16px;
  font-family: 'Arial', 'Helvetica', sans-serif;
  letter-spacing: 1px;
  transition: opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    color: white;
  }
`;

const InstagramIcon = styled.div`
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-height: 350px;
`;

const Hamburger = styled(IconButton)`
  .menu-icon {
    font-size: 2rem;
  }
  @media (min-width: 1043px) {
    .menu-icon {
      display: none;
    }
  }
  @media (min-width: 650px) {
    .menu-icon {
      font-size: 3rem;
    }
  }
`;
const StyledBox = styled(Box)`
  margin-right: 1px;
`;
